import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2 my-6 flex flex-col space-y-6" }

import { ref } from 'vue';
import HomeProgress from '../../components/HomeProgress.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  homeId: {
    type: String,
    required: false,
    default: '123',
  },
},
  setup(__props) {



// const auth = useAuth()
// const homes = useHomes()
const homes = ref<any>({
  activeHome: {},
});
const auth = ref({
  currentUser: {
    authenticated: true,
    data: [],
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (homes.value.activeHome && auth.value.currentUser)
      ? (_openBlock(), _createBlock(HomeProgress, {
          key: 0,
          home: homes.value.activeHome,
          user: auth.value.currentUser
        }, null, 8, ["home", "user"]))
      : _createCommentVNode("", true)
  ]))
}
}

})